import styled, { css } from 'styled-components'
import { themeGet } from 'styled-system'

const breadcrumbColor = ({ isLight }) =>
  isLight ? themeGet('colors.white') : themeGet('colors.textBase')

const breadcrumbText = css`
  color: ${breadcrumbColor};
  font-family: ${themeGet('font.molde.regular', 'Molde-regular')};
  font-size: 1rem;
  line-height: 1.2;
`

export const BreadcrumbBar = styled.nav`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  background-color: transparent;
`

export const BreadcrumbInner = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 1.25rem 0 1.5rem;
`

export const BreadcrumbList = styled.ol`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
`

export const BreadcrumbItem = styled.li`
  display: flex;
  align-items: center;
`

export const BreadcrumbSeparator = styled.span`
  ${breadcrumbText}
  margin: 0 0.25rem;
`

export const BreadcrumbCurrent = styled.span`
  ${breadcrumbText}
`

export const BreadcrumbLink = styled.a`
  ${breadcrumbText}
  text-decoration: none;
  text-underline-offset: 0.15rem;

  &:hover {
    color: ${breadcrumbColor};
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 0.125rem solid ${breadcrumbColor};
    outline-offset: 0.125rem;
  }
`
